<ng-content select="trigger" />
<div class="wrapper">
  @if (open()) {
    <div
      @openClose
      (@openClose.start)="onAnimationStart($event)"
      role="region"
      [id]="ariaId()"
      [attr.aria-labelledby]="ariaLabelledBy()"
    >
      <ng-content />
    </div>
  }
</div>
